import { FETCH_FILTred_STOCK } from "../actions/types";

export default function (state = [], action) {
  switch (action.type) {
    case FETCH_FILTred_STOCK:
      return action.payload;
    default:
      return state;
  }
}
